import { createContext, useContext } from 'react'

export enum MenuVariant {
  DEFAULT = 'defaultMenu',
  CONTEXT = 'contextMenu',
}

type MenuContextType = {
  variant: MenuVariant
}

export const MenuContext = createContext<MenuContextType>(null)

export const useMenuContext = (): MenuContextType => {
  const context = useContext(MenuContext)

  if (!context) throw new Error('This component must be used within a <MenuLayout> component')

  return context
}
